module.exports = __webpack_public_path__ + "img/vertical_line.093d7afd.svg";